import { useNavigate, NavigateOptions } from 'react-router-dom'
import { useLanguage } from '@/contexts/LanguageContext'

export const useLocalizedNavigate = () => {
  const navigate = useNavigate()
  const { language } = useLanguage()

  return (to: string, options?: NavigateOptions) => {
    // If the path already starts with a language prefix, don't add another
    if (to.match(/^\/[a-z]{2}(\/|$)/)) {
      navigate(to, options)
    } else {
      navigate(`/${language}${to}`, options)
    }
  }
}
